/* 🤖 this file was generated by svg-to-ts */
export const mgcIconUpSmallCuteRe: {
  name: 'up-small-cute-re';
  data: string;
} = {
  name: 'up-small-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.529 9.353c-.237.085-.475.241-.957.626a10.744 10.744 0 0 0-1.905 2.001c-.398.54-.477.704-.479.995-.005.721.67 1.199 1.339.947.256-.097.347-.188.785-.791a9.372 9.372 0 0 1 1.369-1.472l.319-.266.319.266c.438.365 1.019.99 1.369 1.472.438.603.529.694.785.791.847.32 1.636-.554 1.235-1.368-.133-.271-.638-.943-1.085-1.445-.583-.655-1.55-1.469-2.015-1.697a1.583 1.583 0 0 0-1.079-.059"/></svg>`
};
